import React from 'react';
import ReactDOM from 'react-dom';

import './styles.css';
import './styles.scss';
import App from './app';

const rootElement = document.getElementById('root');
ReactDOM.render(<App />, rootElement);
